document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.marquee-wrapper');
  marquees.forEach(wrapper => {
    const speed = parseFloat(wrapper.style.animationDuration);
    const clone = wrapper.cloneNode(true);
    wrapper.parentElement.appendChild(clone);
  });
});
